export default {
  data: () => ({
    translations: {
      step6Title: {
        el: `Επιλέξτε τον τρόπο επικοινωνίας με τον πελάτη και τα κανάλια που θα χρησιμοποιηθούν. `,
        en: `Choose how to communicate with customer and the channels to be used.`,
        it: `Scegliere come comunicare con il cliente e i canali da utilizzare.`,
      },
      notificationChannel: {
        el: 'Κανάλι Ειδοποιήσεων',
        en: 'Notification Channel',
        it: 'Canale di Νotifica',
      },
      firstSelection: {
        el: 'Πρώτη Επιλογή',
        en: 'First Selection',
        it: 'Prima opzione',
      },
      secondSelection: {
        el: 'Δεύτερη Επιλογή',
        en: 'Second Selection',
        it: 'Seconda opzione',
      },
      thirdSelection: {
        el: 'Τρίτη Επιλογή',
        en: 'Third Selection',
        it: 'Terza opzione',
      },
      campaignType: {
        el: 'Τύπος Καμπάνιας',
        en: 'Campaign Type',
        it: 'Tipo di Campagna',
      },
      singleExecution: {
        el: 'Εκτέλεση μία φορά',
        en: 'Single execution',
        it: 'Esecuzione una volta',
      },
      repeatExecution: {
        el: 'Επαναλαμβανόμενη Εκτέλεση',
        en: 'Repeat execution',
        it: 'Esecuzione ripetuta',
      },
      basedOnUserActions: {
        el: 'Με βάση ενέργειες χρηστών',
        en: 'Based on User Actions',
        it: "In base alle azioni dell'utente",
      },
      newTransactionAction: {
        el: 'Ενέργεια νέας συναλλαγής',
        en: 'New transaction action',
        it: 'Nuova azione di transazione',
      },
      transactionsGoal: {
        el: 'Στόχοι Συναλλαγών',
        en: 'Transactions goal action',
        it: 'Obiettivi della transazione',
      },
      transactionsProducts: {
        el: 'Συναλλαγή με συγκεκριμένα προϊόντα',
        en: 'Transaction with specific products',
        it: 'Transazione con prodotti specifici',
      },
      executeAfterMinutes: {
        el: 'Εκτέλεση καμπάνιας μετά από X λεπτά από τη συναλλαγή',
        en: 'Execute campaign X minutes after the transaction',
        it: 'Esegui campagna dopo X minuti dalla transazione',
      },
      executeAfterGoalMinutes: {
        el: 'Εκτέλεση καμπάνιας X λεπτά μετά από τη επίτευξη του στόχου',
        en: 'Campaign execution after X minutes from reaching the target',
        it: "Esecuzione della campagna X minuti dopo il raggiungimento dell'obiettivo",
      },
      transactionsAfterCampaignCreation: {
        el: 'Ελάχιστος αριθμός συναλλαγών',
        en: 'Minimum number of transactions',
        it: 'Numero minimo di transazioni',
      },
      chooseDate: {
        el: 'Επιλέξτε την ημέρα και την ώρα που θέλετε να τερματιστεί η καμπάνια σας',
        en: 'Choose the start and end date for your campaign.',
        it: "Seleziona il giorno e l'ora in cui vuoi che la tua campagna finisca",
      },
      informativeTitleStep2: {
        el: 'Επιλέξτε τις ημέρες και την ώρες που θέλετε να γίνει η καμπάνια σας',
        en: 'Choose the dates for your campaign.',
        it: 'Scegliete le date della vostra campagna.',
      },
      actionTitleStep2: {
        el: 'Επιλέξτε τις ημέρες και την ώρες που θέλετε να γίνει η καμπάνια σας',
        en: 'Choose the dates for your campaign.',
        it: 'Scegliete le date della vostra campagna.',
      },
      titleStep3: {
        el: 'Επιλέξτε τους όρους της καμπάνιας σας.',
        en: 'Choose the conditions for your campaign.',
        it: 'Scegliere le condizioni per i clienti della campagna.',
      },
      titleStep4: {
        el: 'Επιλέξτε τα χαρακτηριστικά των πελατών',
        en: 'Choose the clients characteristics',
        it: 'Scegliere le caratteristiche dei clienti',
      },
      startDate: {
        el: 'Έναρξη',
        en: 'Start Date',
        it: 'Lancia',
      },
      submitCampaign: {
        el: 'Υποβολή Kαμπάνιας',
        en: 'Submit Campaign',
        it: 'Invia Campagna',
      },
      titleCampaign: {
        el: 'Τίτλος Kαμπάνιας',
        en: 'Campaign Title',
        it: 'Titolo della Campagna',
      },
      fillTitleCampaign: {
        el: 'Συμπληρώστε τον τίτλο της καμπάνιας',
        en: 'Fill in the Campaign Title',
        it: 'Compilare il titolo della campagna',
      },
      endDate: {
        el: 'Λήξη',
        en: 'End Date',
        it: 'Fine',
      },
      back: {
        el: 'Πίσω',
        en: 'Back',
        it: 'Indietro',
      },
      next: {
        el: 'Επόμενο',
        en: 'Next',
        it: 'Prossimo',
      },
      descriptionDate: {
        el: 'Ορίστε την ημερομηνία και την ώρα έναρξης της καμπάνιας στα παρακάτω πεδία. Προσοχή! Μετά από αυτή την ημερομηνία και ώρα, η καμπάνια σας θα τερματιστεί.',
        en: "Set the campaign's start date and time in the fields below. Caution! After that date and time, your campaign will be terminated.",
        it: "Imposta la data e l'ora di inizio della campagna nei campi sottostanti. Attenzione! Dopo questa data e ora, la tua campagna sarà terminata.",
      },
      descriptionTime: {
        el: 'Επιλέξτε τις ημέρες και την ώρα που θέλετε να τρέξετε την καμπάνια σας και στη συνέχεια καθορίστε τον τρόπο τερματισμού της.',
        en: 'Choose the days and time you want the campaign to run and define when to termniate it.',
        it: "Scegliete i giorni e l'ora in cui volete eseguire la vostra campagna e poi specificate come volete terminarla.",
      },
      monday: {
        el: 'Δευτέρα ',
        en: 'Monday',
        it: 'Lunedì',
      },
      tuesday: {
        el: 'Τρίτη',
        en: 'Tuesday',
        it: 'Martedì',
      },
      wednesday: {
        el: 'Τετάρτη',
        en: 'Wednesday',
        it: 'Mercoledì',
      },
      thursday: {
        el: 'Πέμπτη',
        en: 'Thursday',
        it: 'Giovedì',
      },
      friday: {
        el: 'Παρασκευή',
        en: 'Friday',
        it: 'Venerdì',
      },
      saturday: {
        el: 'Σάββατο',
        en: 'Saturday',
        it: 'Sabato',
      },
      sunday: {
        el: 'Κυριακή',
        en: 'Sunday',
        it: 'Domenica',
      },
      minAmmount: {
        el: 'Ελάχιστο Ποσό ανά Συναλλαγής',
        en: 'Minimum amount per transaction',
        it: 'Importo minimo per transazione',
      },
      minPoints: {
        el: 'Ελάχιστοι πόντοι ανά συναλλαγή',
        en: 'Minimum points per transaction',
        it: 'Punti minimi per transazione',
      },
      maxEntries: {
        el: 'Μέγιστες συμμετοχές ανά χρήστη',
        en: 'Maximum entries per participant',
        it: 'Numero massimo di iscrizioni per partecipante',
      },
      transactionTypes: {
        el: 'Επιλέξτε Τύπους Συναλλαγής',
        en: 'Select Transaction Types',
        it: 'Selezionare il tipi di transazione',
      },
      offlineRegistrationPoints: {
        el: 'Offline Πόντοι Εγγραφής',
        en: 'Offline Registration Points',
        it: 'Offline Punti di Registrazione',
      },
      onlineRegistrationPoints: {
        el: 'Online Πόντοι Εγγραφής',
        en: 'Online Registration Points',
        it: 'Online Punti di Registrazione',
      },
      mobileOrder: {
        el: 'Παραγγελία μέσω Εφαρμογής',
        en: 'Mobile Order',
        it: 'Ordina via App',
      },
      posOrder: {
        el: 'POS Συναλλαγή',
        en: 'POS Order',
        it: 'Transazione POS',
      },
      campaignAction: {
        el: 'Προωθητική Ενέργεια',
        en: 'Campaign Action',
        it: 'Azione della Campagna',
      },
      couponClaim: {
        el: 'Εξαργύρωση Κουπονιού',
        en: 'Coupon Claim',
        it: 'Azione della Campagna',
      },
      refund: {
        el: 'Επιστροφή Χρημάτων',
        en: 'Refund',
        it: 'Rimborso',
      },
      inStoreOrder: {
        el: 'Παραγγελία στο Κατάστημα',
        en: 'In Store Order',
        it: 'Ordine in Negozio',
      },
      androidPOSOrder: {
        el: 'Παραγγελία από Android POS',
        en: 'Android POS Order',
        it: 'Ordine POS Android',
      },
      refundPoints: {
        el: 'Πόντοι Επιστροφής Χρημάτων',
        en: 'Refund Points',
        it: 'Punti di Rimborso',
      },
      synergyAction: {
        el: 'Δράση Συνέργειας',
        en: 'Synergy Action',
        it: 'Azione Sinergica',
      },
      receiptScanning: {
        el: 'Σάρωση Απόδειξης',
        en: 'Receipt Scanning',
        it: 'Scansione Scontrini',
      },
      purchasedProducts: {
        el: 'Αγορασμένα προϊόντα',
        en: 'Purchased Products',
        it: 'Prodotti acquistati',
      },
      minQuantity: {
        el: 'Ελάχιστη ποσότητα αγορασμένων προϊόντων',
        en: 'Minimum quantity of purchased products',
        it: 'Quantità minima di prodotti acquistati',
      },
      participantsFilters: {
        el: 'Φίλτρα Συμμετεχόντων',
        en: "Participant's Filters",
        it: 'Filtri Partecipanti',
      },
      allClients: {
        el: 'Επιλογή όλων των πελατών',
        en: 'All clients',
        it: 'Selezione di tutti i clienti',
      },
      customersBasedOnLocation: {
        el: 'Πελάτες βάση τοποθεσίας',
        en: 'Customers based on location',
        it: 'Clienti per località',
      },
      customerConditions: {
        el: 'Φίλτρα Συμμετεχόντων',
        en: "Participant's Filters",
        it: 'Filtri Partecipanti',
      },
      customersLeastTransactions: {
        el: 'Πελάτες που πραγματοποιούν τουλάχιστον Χ συναλλαγές σε συγκεκριμένα καταστήματα',
        en: 'Customers who complete at least X transactions at specific stores',
        it: 'Clienti che effettuano almeno X transazioni in negozi specifici',
      },
      customersFirstTransactions: {
        el: 'Πελάτες που πραγματοποιούν τις πρώτες Χ τους συναλλαγές σε συγκεκριμένα καταστήματα',
        en: 'Customers who complete their first X transactions at specific stores',
        it: 'Clienti che effettuano le loro prime X transazioni in negozi specifici',
      },
      csvFile: {
        el: 'Πελάτες από αρχείο CSV με συγκεκριμένη μορφή',
        en: 'Customers from a CSV file',
        it: 'Clienti da un file CSV con un formato specifico',
      },
      customersPurchaseProduct: {
        el: 'Πελάτες που αποκτούν συγκεκριμένα προϊόντα (προϊόντα ομπρέλας) από συγκεκριμένα καταστήματα',
        en: 'Customers who purchase specific products (umbrella products) from specific stores',
        it: 'Clienti che acquistano prodotti specifici (prodotti ombrello) da negozi specifici',
      },
      previousCampaign: {
        el: 'Πελάτες που συμπεριλήφθηκαν σε προηγούμενη καμπάνια',
        en: 'Customers included in a previous campaign',
        it: 'Clienti inclusi in una campagna precedente',
      },
      specificCoupons: {
        el: 'Πελάτες που έχουν εξαργυρώσει συγκεκριμένα κουπόνια από συγκεκριμένα καταστήματα',
        en: 'Customers who redeemed specific coupons from specific stores',
        it: 'Clienti che hanno riscattato coupon specifici da negozi specifici',
      },
      olderCampaign: {
        el: 'Πελάτες που έχουν λάβει παλαιότερη καμπάνια',
        en: 'Clients that have received older campaign',
        it: 'Clienti che hanno ricevuto una campagna precedente',
      },
      certainShops: {
        el: 'Πελάτες που εξαργύρωσαν κουπόνια σε συγκεκριμένα καταστήματα',
        en: 'Clients that redeemed certain coupons from certain shops',
        it: 'Clienti che hanno riscattato determinati coupon da determinati negozi',
      },
      address: {
        el: 'Διεύθυνση',
        en: 'Address',
        it: 'Indirizzo',
      },
      radius: {
        el: 'Ακτίνα σε χλμ.',
        en: 'Radius in km',
        it: 'Raggio in km',
      },
      minAmountSpent: {
        el: 'Ελάχιστο Ποσό',
        en: 'Min amount spent',
        it: 'Importo minimo',
      },
      requiredTransactions: {
        el: 'Αριθμός συναλλαγών μετά την καμπάνια',
        en: 'Required number of transactions after campaign has been set up',
        it: 'Numero di transazioni dopo la campagna',
      },
      stores: {
        el: 'Καταστήματα',
        en: 'Stores',
        it: 'Negozi',
      },
      transactionsCompletedFrom: {
        el: 'Οι συναλλαγές ολοκληρώθηκαν από',
        en: 'Transactions completed from',
        it: 'Transazioni Completate da',
      },
      transactionsCompletedUpTo: {
        el: 'Οι συναλλαγές ολοκληρώθηκαν μέχρι',
        en: 'Transactions completed up to',
        it: 'Transazioni Completate fino a',
      },
      containLoyaltyCards: {
        el: 'Το αρχείο πρέπει να περιέχει τους αριθμούς πιστότητας των πελατών και πρέπει να είναι σε μορφή αρχείου CSV.',
        en: "The file must contain the customers' loyalty numbers and must be in CSV file format.",
        it: 'Il file deve contenere i numeri fedeltà dei clienti e deve essere in formato file CSV.',
      },
      products: {
        el: 'Προϊόντα',
        en: 'Products',
        it: 'Prodotti',
      },
      campaign: {
        el: 'Καμπάνια',
        en: 'Campaign',
        it: 'Campagna',
      },
      coupon: {
        el: 'Κουπόνια',
        en: 'Coupons',
        it: 'Coupons',
      },
      couponRedeemedBetween: {
        el: 'Το κουπόνι εξαργυρώθηκε μεταξύ (ημ/νία)',
        en: 'Coupon was redeemed between (date)',
        it: 'Il coupon è stato riscattato tra (data)',
      },
      couponRedeemedUpTo: {
        el: 'Το κουπόνι εξαργυρώθηκε μέχρι (ημερομηνία)',
        en: 'Coupon was redeemed up to (date)',
        it: 'Il coupon è stato riscattato fino a (data)',
      },
      participantsSubfilters: {
        el: 'Δευτερεύοντα Φίλτρα Συμμετεχόντων',
        en: 'Secondary Participant Filters',
        it: 'I filtri dei partecipanti sono secondari',
      },
      noSubfilters: {
        el: 'Δεν χρειάζονται υποφίλτρα',
        en: 'No subfilters needed',
        it: 'Non sono necessari sottofiltri',
      },
      gender: {
        el: 'Φύλο',
        en: 'Gender',
        it: 'Sesso',
      },
      genderChoose: {
        el: 'Επιλέξτε Φύλο',
        en: 'Choose Gender',
        it: 'Scegliere il genere',
      },
      wonBetween: {
        el: 'Κέρδισε μεταξύ Χ και Υ πόντους',
        en: 'Won between X and Y points',
        it: 'Ha vinto tra i punti X e Y',
      },
      completedBetween: {
        el: 'Ολοκλήρωσε μεταξύ Χ και Υ συναλλαγές',
        en: 'Completed between X and Y transactions',
        it: 'Completato tra le transazioni X e Y',
      },
      spentBetween: {
        el: 'Δαπάνησε ποσό αξίας μεταξύ Χ και Υ Ευρώ',
        en: 'Spent between X and Y amount (currency)',
        it: 'Importo in valuta speso tra X e Y',
      },
      transactionsFrequency: {
        el: 'Ολοκλήρωσε συναλλαγές σε συγκεκριμένη συχνότητα',
        en: 'Completed transactions at a specific frequency',
        it: 'Transazioni completate a una frequenza specifica',
      },
      transactionsHours: {
        el: 'Ολοκληρώθηκε μια συναλλαγή κατά τη διάρκεια συγκεκριμένων ωρών',
        en: 'Completed a transaction during specific hours',
        it: 'Hai completato una transazione in orari specifici',
      },
      registrationBetweenDates: {
        el: 'Εγγραφή μεταξύ συγκεκριμένων ημερομηνιών',
        en: 'Registration between specific dates',
        it: 'Registrato tra date specifiche',
      },
      filterCustomerDesc: {
        el: 'Φιλτράρετε την επιλογή πελατών κατά άντρες, γυναίκες ή άλλα.',
        en: 'Filter the customer selection by men, women or other. ',
        it: 'Filtra la selezione dei clienti per uomini, donne o altri.',
      },
      male: {
        el: 'Αρσενικό',
        en: 'Male',
        it: 'Maschio',
      },
      female: {
        el: 'Θηλυκό',
        en: 'Female',
        it: 'Femminile',
      },
      all: {
        el: 'Όλα',
        en: 'All',
        it: 'Tutti',
      },
      other: {
        el: 'Άλλο',
        en: 'Other',
        it: 'Altro',
      },
      storesSelected: {
        el: 'Επιλεγμένα Καταστήματα',
        en: 'Stores Selected',
        it: 'Negozi selezionati',
      },
      productsSelected: {
        el: 'Επιλεγμένα Προϊόντα',
        en: 'Products Selected',
        it: 'Prodotti selezionati',
      },
      couponsSelected: {
        el: 'Επιλεγμένα Κουπόνια',
        en: 'Coupons Selected',
        it: 'Tagliandi selezionati',
      },
      basedOnMinMax: {
        el: 'Επιλέξτε πελάτες με βάση έναν ελάχιστο ή/και έναν μέγιστο αριθμό πόντων που έχουν κερδίσει μέσω των συναλλαγών τους (π.χ. πελάτες που έχουν κερδίσει μεταξύ 20 και 100 πόντους ή πελάτες που έχουν κερδίσει πάνω από 100 πόντους).',
        en: 'Select customers based on a min and/or max number of points earned through their transactions (e.g. customers who have earned between 20 and 100 points or customers who have earned over 100 points).',
        it: 'Selezionare i clienti in base a un numero minimo e/o massimo di punti guadagnati attraverso le loro transazioni (ad esempio, clienti che hanno guadagnato tra 20 e 100 punti o clienti che hanno guadagnato più di 100 punti)',
      },
      minimumPoints: {
        el: 'Ελάχιστοι πόντοι',
        en: 'Minimum Points',
        it: 'Punti minimi',
      },
      maximumPoints: {
        el: 'Μέγιστοι πόντοι',
        en: 'Maximum Points',
        it: 'Punti massimi',
      },
      basedOnMinMaxAge: {
        el: 'Επιλέξτε πελάτες με βάση την ηλικία τους ή/και τα γενέθλιά τους (π.χ. πελάτες που είναι μεταξύ 18 - 68 ετών ή/και έχουν γενέθλια την ημέρα εκτέλεσης της καμπάνιας).',
        en: 'Select customers based on their age or/and their birthdays (e.g. customers who are between 18 - 68 years old or/and have birthday the day the campaign executes).',
        it: 'Selezionare i clienti in base alla loro età o al loro compleanno (ad esempio, clienti di età compresa tra i 18 e i 45 anni o che compiono gli anni il giorno in cui viene eseguita la campagna)..',
      },
      minNumber: {
        el: 'Ελάχιστος αριθμός συναλλαγών',
        en: 'Minimum Number of Transactions',
        it: 'Numero minimo di transazioni',
      },
      maxNumber: {
        el: 'Μέγιστος αριθμός συναλλαγών',
        en: 'Maximum Number of Transactions',
        it: 'Numero massimo di transazioni',
      },
      maxAge: {
        el: 'Μέγιστη ηλικία',
        en: 'Maximum Age',
        it: 'Età massima',
      },
      minAge: {
        el: 'Ελάχιστη ηλικία',
        en: 'Minimum Age',
        it: 'Età minima',
      },
      basedOnMinMaxSpent: {
        el: 'Επιλέξτε πελάτες με βάση ένα ελάχιστο ή/και ένα μέγιστο ποσό αγορών (π.χ. πελάτες που έχουν συναλλαγές συνολικής αξίας μεταξύ 5 και 50 ευρώ ή πελάτες που έχουν συναλλαγές συνολικής αξίας άνω των 50 ευρώ).',
        en: 'Select customers based on a minimum and/or maximum purchase amount (e.g. customers who have transactions with a total value between €5 and €50 or customers who have transactions with a total value over €50).',
        it: 'Selezionare i clienti in base a un importo di acquisto minimo e/o massimo (ad esempio, clienti che hanno effettuato transazioni per un valore totale compreso tra 5 e 50 euro o clienti che hanno effettuato transazioni per un valore totale superiore a 50 euro).',
      },
      basedOnRegistrationDate: {
        el: 'Επιλέξτε πελάτες με βάση την ημερομηνία εγγραφής τους (π.χ. πελάτες που γράφτηκαν μεταξύ 1ης Ιανουαρίου και 1ης Μαρτίου ή πελάτες που γράφτηκαν μετά την 1η Ιανουαρίου).',
        en: 'Select customers based on their registration date (e.g. customers who registered on a date between 1st of January and 1st of March or customers who registered past 1st of January).',
        it: 'Selezionare i clienti in base alla loro data di registrazione (ad esempio, i clienti che si sono registrati in una data compresa tra il 1° gennaio e il 1° marzo o i clienti che si sono registrati dopo il 1° gennaio).',
      },
      minimumAmountSpent: {
        el: 'Ελάχιστο ποσό που δαπανήθηκε',
        en: 'Minimum Amount Spent',
        it: 'Importo minimo speso',
      },
      maximumAmountSpent: {
        el: 'Μέγιστο ποσό που δαπανήθηκε',
        en: 'Maximum Amount Spent',
        it: 'Importo massimo speso',
      },
      basedOnCompleteTransactions: {
        el: 'Επιλέξτε πελάτες με βάση τη συχνότητα ολοκλήρωσης συναλλαγών στην εταιρεία σας (π.χ. πελάτες που αγοράζουν τα προϊόντα σας κάθε 3 - 30 ημέρες).',
        en: 'Select customers based on how often they complete transactions at your company (e.g. customers who buy your products every 3 - 30 days).',
        it: 'Seleziona i clienti in base alla frequenza con cui completano le transazioni presso la tua azienda (ad esempio i clienti che acquistano i tuoi prodotti ogni 3 - 30 giorni).',
      },
      minimumTransactionFrequency: {
        el: 'Ελάχιστη συχνότητα συναλλαγής',
        en: 'Minimum Transaction Frequency',
        it: 'Frequenza minima di transazione',
      },
      maximumTransactionFrequency: {
        el: 'Μέγιστη συχνότητα συναλλαγής',
        en: 'Maximum Transaction Frequency',
        it: 'Frequenza massima delle transazioni',
      },
      basedOnTime: {
        el: 'Επιλέξτε πελάτες με βάση την ώρα της ημέρας που ολοκληρώνουν τις συναλλαγές (π.χ. πελάτες που αγοράζουν τα προϊόντα σας μετά τις 8 το βράδυ).',
        en: 'Select customers based on the time of day they complete transactions (e.g. customers who buy your products after 8 pm).',
        it: "Seleziona i clienti in base all'ora del giorno in cui completano le transazioni (ad esempio i clienti che acquistano i tuoi prodotti dopo le 20:00).",
      },
      earliestTimeOfTransaction: {
        el: 'Από ώρα (συναλλαγής)',
        en: 'Earliest Time of Transaction',
        it: 'Prima ora della transazione',
      },
      latestTimeOfTransaction: {
        el: 'Εώς ώρα (συναλλαγής)',
        en: 'Latest Time of Transaction',
        it: 'Ultima ora della transazione',
      },
      date1: {
        el: 'Ημ/νία 1',
        en: 'Date 1',
        it: 'Data 1',
      },
      date2: {
        el: 'Ημ/νία 2',
        en: 'Date 2',
        it: 'Data 2',
      },
      customerReward: {
        el: 'Επιβράβευση Πελάτη',
        en: 'Customer Reward',
        it: 'Premio cliente',
      },
      atLeastOneReward: {
        el: 'Προσθέστε τουλάχιστον μία ανταμοιβή με θετική τιμή (> 0) για να συνεχίσετε.',
        en: 'Please add at least one reward with a positive value (>0) to continue.',
        it: 'Aggiungi almeno un premio con un valore positivo (>0) per continuare.',
      },
      rewardPoints: {
        el: 'Πόντοι',
        en: 'Reward Points',
        it: 'Punti',
      },
      typeRewardPointsNumber: {
        el: 'Πληκτρολογήστε τον αριθμό των πόντων',
        en: 'Type in the number of points',
        it: 'Digitare il numero di punti',
      },

      rewardPointsDescription: {
        el: 'Πληκτρολογήστε τον αριθμό των πόντων που θα ανταμειφθούν στους συμμετέχοντες αυτής της καμπάνιας.',
        en: 'Type in the number of points that will be rewarded to the participants of this campaign.',
        it: 'Digitare il numero di punti che verranno assegnati ai partecipanti a questa campagna.',
      },
      multiPointsChoose: {
        el: 'Επιλέξτε πολλαπλασιαστή',
        en: 'Choose a multiplier',
        it: 'Scegliere un moltiplicatore',
      },
      multiPointsDesc: {
        el: 'Ο πολλαπλασιαστής θα διαμορφώνει τους πόντους που κερδίζουν οι πελάτες κατα την διάρκεια της καμπάνιας (πχ. διπλάσιους πόντους από συναλλαγές).',
        en: 'The multiplier will modulate the points earned by customers during the campaign (e.g. double points from transactions).',
        it: 'Il moltiplicatore modulerà i punti guadagnati dai clienti durante la campagna (ad esempio, raddoppiando i punti delle transazioni).',
      },
      titleAndContent: {
        el: 'Τίτλος & Περιεχόμενο',
        en: 'Title and Content',
        it: 'Titolo e contenuto',
      },
      campaignImage: {
        el: 'Εικόνα Καμπάνιας',
        en: 'Campaign Image',
        it: 'Immagine della campagna',
      },
      title: {
        el: 'Τίτλος',
        en: 'Title',
        it: 'Titolo',
      },
      text: {
        el: 'Κείμενο',
        en: 'Text',
        it: 'Testo',
      },
      submit: {
        el: 'Υποβολή',
        en: 'Submit',
        it: 'Invia',
      },
      customerRewardDescription_points: {
        el: 'Προσθέστε έναν τρόπο επιβράβευσης. Για επιβράβευση με πόντους, το ελάχιστο πόντων είναι 0 (πχ. πληροφοριακή καμπάνια).',
        en: 'Please select one reward type. For reward points, the minimum value is 0 (e.g. informative campaign).',
        it: 'Aggiungi un modo per premiare. Per un premio con punti, il numero minimo di punti è 0 (es. campagna informativa).',
      },
      customerRewardDescription_cashback: {
        el: 'Προσθέστε έναν τρόπο επιβράβευσης. Για επιβράβευση με cashback, το ελάχιστο ποσό είναι 0 (πχ. πληροφοριακή καμπάνια).',
        en: 'Please select one reward type. For reward cashback, the minimum value is 0 (e.g. informative campaign).',
        it: "Aggiungi un modo per premiare. Per un premio con cashback, l'importo minimo è 0 (es. campagna informativa).",
      },
      customerConditionsDescription: {
        el: 'Το αρχείο θα πρέπει να περιέχει μία στήλη με αριθμούς κινητών των πελατών. Εάν θέλετε να προσθέσετε συμμετέχοντες με βάση τους αριθμούς καρτών αφοσίωσης, προσθέστε μια δεύτερη στήλη με τους αριθμούς καρτών. Οι στήλες δεν θα πρέπει να περιέχουν τίτλους. Η αποδεκτή μορφή αρχείου είναι CSV.',
        en: 'The file should contain one column with customer mobile numbers. If you would like to add participants based on loyalty card numbers, please add a second column with the card numbers. Please do not add titles to the columns. The acceptable file format is CSV.',
        it: 'Il file dovrebbe contenere una colonna con i numeri di cellulare dei clienti. Se desideri aggiungere partecipanti in base ai numeri della carta fedeltà, aggiungi una seconda colonna con i numeri della carta. Le colonne non devono contenere titoli. Il formato file accettato è CSV.',
      },
      mobileInputLabel: {
        el: 'Κινητό',
        en: 'Mobile',
        it: 'Mobile',
      },
      invoicingSettings: {
        el: 'Επιλογές Τιμολόγησης',
        en: 'Invoicing Settings',
        it: 'Impostazioni di fatturazione',
      },
      invoicingShare: {
        el: 'Το κατάστημα θα μοιραστεί μέρος ή όλο το σύνολο της επιβάρυνσης για τους πόντους της καμπάνιας.',
        en: 'The store will share some or all of the charge for the campaign’s points.',
        it: 'Il negozio condividerà in tutto o in parte il costo dei punti della campagna.',
      },
      invoicingSettingsDescription: {
        el: 'Παρακαλώ επιλέξτε ποιος θα χρεωθεί τους πόντους της καμπάνιας',
        en: 'Please select who will be charged for the campaign’s points.',
        it: 'Seleziona a chi verranno addebitati i punti della campagna.',
      },
      companyPercentage: {
        el: 'Ποσοστό Εταρείας (%)',
        en: 'Company Percentage (%)',
        it: 'Percentuale aziendale (%)',
      },
      radioFirst: {
        el: 'Εταιρεία',
        en: 'Company',
        it: 'Societa',
      },
      radioSecond: {
        el: 'Κατάστημα',
        en: 'Store',
        it: 'Negozio',
      },
      radioThird: {
        el: 'Εταιρεία & Κατάστημα',
        en: 'Company & Store',
        it: 'Societa & Negozio',
      },
      maximumEntriesPerParticipant: {
        el: 'Μέγιστός αριθμός συμμετοχών για τον κάθε συμμετέχοντα',
        en: 'Maximum entries per participant',
        it: 'Numero massimo di iscrizioni per ogni partecipante',
      },
      minAmountRule: {
        el: 'Το ελάχιστο ποσό θα πρέπει να συμπληρωθεί για τουλάχιστον ένα από τα επιλεγμένα προϊόντα',
        en: 'Minimum amount must be completed for at least one of the selected products',
        it: "L'importo minimo deve essere completato per almeno uno dei prodotti selezionati",
      },
      afterTheCampaignCreation: {
        el: 'Πελάτες που πραγματοποιούν τουλάχιστον Χ συναλλαγές μετά την δημιουργία καμπάνιας',
        en: 'Customers who complete X transactions after the campaign creation',
        it: 'Clienti che effettuano almeno X transazioni dopo aver creato una campagna',
      },
      lastTransactionDate: {
        el: 'Ημερομηνία τελευταίας συναλλαγής',
        en: 'Last transaction date',
        it: "Data dell'ultima transazione",
      },
      date: {
        el: 'Ημερομηνία',
        en: 'Date ',
        it: 'Data ',
      },
      days: {
        el: 'Ημέρες ',
        en: 'Days ',
        it: 'Giorni ',
      },
      hours: {
        el: 'Ώρες ',
        en: 'Hours ',
        it: 'Orario ',
      },
      from: {
        el: 'Από ',
        en: 'From ',
        it: 'Da ',
      },
      to: {
        el: 'Εώς ',
        en: 'To ',
        it: 'Α',
      },
      fromHour: {
        el: 'Από ώρα',
        en: 'From Hour',
        it: 'Da ora',
      },
      toHour: {
        el: 'Μέχρι ώρα',
        en: 'To Hour',
        it: "L'ora",
      },
      prioritySendTitle: {
        el: 'Αποστολη με προτεραιοτητα',
        en: 'Send with priority',
        it: 'Spedizione prioritaria',
      },
      prioritySendDescription: {
        el: 'Χρήση μόνο ενός καναλιού για κάθε πελάτη. Σε περίπτωση αποτυχίας της πρώτης επιλογής, θα χρησιμοποιηθεί η επόμενη.',
        en: 'Use of only one channel for each customer. In case of failure of the first option, the next one will be used.',
        it: 'Usare un solo canale per ogni cliente. In caso di fallimento della prima opzione, verrà utilizzata la successiva.',
      },
      allChannelSendTitle: {
        el: 'Αποστολη μεσω ολων των καναλιων',
        en: 'Send via all channels',
        it: 'Invia tramite tutti i canali',
      },
      allChannelSendDescription: {
        el: 'Χρήση όλων των δυνατών επιλογών για κάθε πελάτη.',
        en: 'Use of all possible options for each customer.',
        it: 'Utilizzo di tutte le opzioni possibili per ogni cliente.',
      },
      uniqueParticipants: {
        el: 'Οι χρήστες στο αρχείο είναι μοναδικοί και ο καθένας θα πρέπει να συμπεριληφθεί μία φορά στους συμμετέχοντες.',
        en: 'Users in file are unique and each one should be included once into participants.',
        it: 'Gli utenti del file sono unici e ciascuno di essi deve essere incluso una sola volta nei partecipanti.',
      },
      selectCategory: {
        el: 'Επιλέξτε κατηγορία',
        en: 'Select Category',
        it: 'Selezionare la categoria',
      },
      informative: {
        el: 'Ενημερωτική',
        en: 'Informative',
        it: 'Informativo',
      },
      draw: {
        el: 'Κλήρωση',
        en: 'Draw',
        it: 'Disegno',
      },
      userAction: {
        el: 'Ενέργεια χρήστη',
        en: 'User Action',
        it: "Azione dell'utente",
      },
      action: {
        el: 'Ενέργεια χρήστη',
        en: 'User Action',
        it: "Azione dell'utente",
      },
      cancel: {
        el: 'Ακύρωση',
        en: 'Cancel',
        it: 'Annullare',
      },
      edit: {
        el: 'Επεξεργασία',
        en: 'Edit',
        it: 'Modifica',
      },
      deactivate: {
        el: 'Aπενεργοποίηση',
        en: 'Deactivate',
        it: 'Disattivare',
      },
      drag: {
        el: 'Σύρετε για αλλαγή θέσης/προτεραιότητας',
        en: 'Drag to change position/priority',
        it: 'Trascinare per cambiare posizione/priorità',
      },
      channelBodyModal: {
        el: 'Περιεχόμενο',
        en: 'Content',
        it: 'Contenuto',
      },
      fallbackContent: {
        el: 'Περιεχόμενο εφεδρικού sms',
        en: 'Fallback sms content',
        it: 'Contenuto degli sms di riserva',
      },
      fallback: {
        el: 'Αποστολή εφεδρικού SMS σε περίπτωση που η υπηρεσία του Viber δεν είναι διαθέσιμη.',
        en: 'Send a fallback SMS in case the Viber service is not available.',
        it: 'Inviare un SMS di backup nel caso in cui il servizio Viber non sia disponibile.',
      },

      smsRewardContent: {
        el: 'Περιεχόμενο sms',
        en: 'Sms content',
        it: 'Contenuto degli sms',
      },
      dynamicRewardSmsDesc1: {
        el: 'Πληκτρολογήστε το περιεχόμενο του μηνύματος ως συνήθως. Χρησιμοποιήστε ',
        en: 'Type in the message content as usual. Use ',
        it: 'Digitare il contenuto del messaggio come di consueto. Utilizzare ',
      },

      dynamicRewardSmsDesc2: {
        el: ' για να εμφανίσετε τον τίτλο του δώρου και ',
        en: ' to display the gift title and ',
        it: ' per visualizzare il titolo del regalo e ',
      },

      dynamicRewardSmsDesc3: {
        el: ' για να εμφανίσετε τον κωδικό του κουπονιού.',
        en: ' to display the coupon code.',
        it: ' per visualizzare il codice del coupon.',
      },

      dynamicRewardSmsVariable: {
        el: 'Σημειώνεται ότι ο αριθμός των χαρακτήρων και το κόστος ανά sms είναι μεταβλητά στην περίπτωση που χρησιμοποιείται το {voucher} ή το {code}. Ο κωδικός του κουπονιού {code} θα αποτελείται από τουλάχιστον 12 χαρακτήρες στο τελικό μήνυμα.',
        en: 'Please note that the number of characters and the cost per sms is variable if {voucher} or {code} is used. The voucher code {code} will consist of at least 12 characters in the final message.',
        it: 'Si noti che il numero di caratteri e il costo per sms variano se si utilizza {voucher} o {code}. Il codice del buono {code} sarà composto da almeno 12 caratteri nel messaggio finale.',
      },

      smsRewardSend: {
        el: 'Αποστολή sms δυναμικού περιεχομένου κατά την επιβράβευση',
        en: 'Send sms with dynamic content with the reward',
        it: 'Inviare sms con contenuto dinamico durante la ricompensa',
      },

      channelTitleModal: {
        el: 'Τίτλος',
        en: 'Title',
        it: 'Titolo',
      },
      channelURLModal: {
        el: 'Διεύθυνση URL',
        en: 'URL',
        it: 'URL',
      },
      channelButtonURL: {
        el: 'Σύνδεσμος κουμπιού',
        en: 'Button URL',
        it: 'URLdel pulsante',
      },
      imageDisplayText: {
        el: 'Θέλω το περιεχόμενο να εμφανίζεται με εικόνα',
        en: 'I want the content to be displayed with an image',
        it: "Voglio che il contento sia visualizzato con un'immagine",
      },
      imageOptional: {
        el: 'Εικόνα (προαιρετικό)',
        en: 'Image (optional)',
        it: 'Immagine (opzionale)',
      },
      image: {
        el: 'Εικόνα',
        en: 'Image',
        it: 'Immagine',
      },
      overrideText: {
        el: 'Παράκαμψη των ρυθμίσεων ειδοποίησης χρήστη',
        en: 'Override user notification settings',
        it: "Annullamento delle impostazioni di notifica dell'utente",
      },
      type_one_time_execution: {
        el: 'Εκτέλεση μίας φοράς',
        en: 'One time execution',
        it: 'Esecuzione una tantum',
      },
      type_repeat_execution: {
        el: 'Επαναλαμβανόμενη εκτέλεση',
        en: 'Repeat execution',
        it: "Ripetere l'esecuzione",
      },
      type_multiple_times_execution: {
        el: 'Πολλαπλή εκτέλεση',
        en: 'Multiple times execution',
        it: 'Esecuzione multipla',
      },
      type_new_transaction: {
        el: 'Ενέργεια νέας συναλλαγής',
        en: 'New transaction action',
        it: 'Nuova azione di transazione',
      },
      type_transaction_goal: {
        el: 'Ενέργεια συναλλαγών στόχου',
        en: 'Transactions goal action',
        it: 'Transazioni obiettivo azione',
      },
      type_transaction_with_specific_products: {
        el: 'Συναλλαγή με συγκεκριμένα προϊόντα',
        en: 'Transaction with specific products',
        it: 'Transazione con prodotti specifici',
      },
      loadMore: {
        el: 'Φόρτωση περισσότερων...',
        en: 'Loading More...',
        it: 'Per saperne di più...',
      },
      validityPeriod: {
        el: 'Περίοδος εγκυρότητας (σε δευτερόλεπτα)',
        en: 'Validity Period (in seconds)',
        it: 'Periodo di validità (in secondi)',
      },
      promotional: {
        el: 'Στο μήνυμα θα υπάρχει εικόνα και κουμπί συνδέσμου (προωθητικό)',
        en: 'There will be an image and a link button in the message (promotional)',
        it: "Nel messaggio saranno presenti un'immagine e un pulsante di collegamento (promozionale)",
      },
      channelButton: {
        el: 'Κείμενο Κουμπιού',
        en: 'Button text',
        it: 'Testo del pulsante',
      },
      all_clientsCondition: {
        el: 'Όλοι οι πελάτες',
        en: 'All clients',
        it: 'Tutti i clienti',
      },
      based_on_locationCondition: {
        el: 'Πελάτες βάσει τοποθεσίας',
        en: 'Clients based on location',
        it: 'Clienti in base alla posizione',
      },
      at_least_transactions_certain_storesCondition: {
        el: 'Πελάτες που έχουν κάνει τουλάχιστον Χ συναλλαγές ελάχιστου ποσού Υ',
        en: 'Clients that have done at least X transactions of minimum Y amount',
        it: 'Clienti che hanno effettuato almeno X transazioni di importo minimo Y',
      },
      first_transactions_certain_storesCondition: {
        el: 'Πελάτες που έχουν πραγματοποιήσει τις πρώτες τους Χ συναλλαγές σε συγκεκριμένα καταστήματα',
        en: 'Clients that have done their first X transactions at certain stores',
        it: 'Clienti che hanno effettuato le loro prime X transazioni in determinati negozi',
      },
      first_transaction_certain_storeCondition: {
        el: 'Πελάτες που έχουν πραγματοποιήσει την πρώτη τους συναλλαγή σε συγκεκριμένο κατάστημα',
        en: 'Clients that have done their first transaction at a certain store',
        it: 'Clienti che hanno effettuato la prima transazione presso un determinato negozio',
      },
      acquired_certain_products_certain_storesCondition: {
        el: 'Πελάτες που έχουν αποκτήσει συγκεκριμένα προϊόντα (προϊόντα ομπρέλα) από συγκεκριμένα καταστήματα',
        en: 'Clients that have acquired certain products (umbrella products) from certain shops',
        it: 'Clienti che hanno acquistato determinati prodotti (prodotti ombrello) da determinati negozi',
      },
      from_older_campaignCondition: {
        el: 'Πελάτες που έχουν λάβει παλαιότερη καμπάνια',
        en: 'Clients that have received older campaign',
        it: 'Clienti che hanno ricevuto una campagna più vecchia',
      },
      redeemed_coupon_certain_storesCondition: {
        el: 'Πελάτες που εξαργύρωσαν συγκεκριμένα κουπόνια από συγκεκριμένα καταστήματα',
        en: 'Clients that redeemed certain coupons from certain shops',
        it: 'Clienti che hanno riscattato determinati coupon da determinati negozi',
      },
      from_csvCondition: {
        el: 'Πελάτες από αρχείο CSV με συγκεκριμένη μορφή',
        en: 'Clients from CSV file with certain format',
        it: 'Clienti da file CSV con un determinato formato',
      },
      x_transactions_certain_stores_after_campaignCondition: {
        el: 'Πελάτες που ολοκληρώνουν Χ συναλλαγές μετά τη δημιουργία της καμπάνιας',
        en: 'Customers who complete X transactions after the campaign creation',
        it: 'Clienti che completano X transazioni dopo la creazione della campagna',
      },
      noneCharacteristic: {
        el: 'Δεν απαιτείται επιμέρους προϋπόθεση',
        en: 'No Sub-Condition Needed',
        it: 'Non sono necessarie sottocondizioni',
      },
      genderCharacteristic: {
        el: 'Φύλο',
        en: 'Gender',
        it: 'Genere',
      },
      points_earnedCharacteristic: {
        el: 'Από Χ έως Υ κερδισμένοι πόντοι/cashback',
        en: 'From X to Y points/cashback earned',
        it: 'Da X a Y punti/cashback guadagnati',
      },
      transactions_completedCharacteristic: {
        el: 'Από Χ έως Υ ολοκληρωμένες συναλλαγές',
        en: 'From X to Y transactions completed',
        it: 'Da X a Y transazioni completate',
      },
      currency_purchasedCharacteristic: {
        el: 'Από X έως Y ευρώ αγορών',
        en: 'From X to Y euro purchased',
        it: 'Da X a Y euro acquistati',
      },
      registration_periodCharacteristic: {
        el: 'Έχει εγγραφεί μεταξύ της ημερομηνίας X και της ημερομηνίας Y',
        en: 'Registered between Date X and Date Y',
        it: 'Registrato tra la data X e la data Y',
      },
      last_transactionCharacteristic: {
        el: 'Tελευταία συναλλαγή',
        en: 'Last transaction',
        it: 'Ultima transazione',
      },
      // birth_dateCharacteristic: {
      //     el: "Ημέρα γενεθλίων",
      //     en: "Birthday",
      //     it: "Giorno del compleanno"
      // },
      store_point_titleCharacteristic: {
        el: 'Επίπεδα',
        en: 'Tiers',
        it: 'Livelli',
      },
      points_reachedCharacteristic: {
        el: 'Πόντοι που επιτεύχθηκαν',
        en: 'Points reached',
        it: 'Punti raggiunti',
      },
      user_account_attributesCharacteristic: {
        el: 'Ιδιότητες λογαριασμού χρήστη',
        en: 'User account attributes',
        it: "Attributi dell'account utente",
      },
      selectTiers: {
        el: 'Επιλογή επιπέδων',
        en: 'Select tiers',
        it: 'Scelta dei livelli',
      },
      selectTiersDis: {
        el: 'Επιλέξτε ένα ή και περισσότερα επίπεδα',
        en: 'Select one or more tiers',
        it: 'Selezionare uno o più livelli',
      },
      typeMinMaxPoints: {
        el: 'Πληκτρολογήστε ένας ελάχιστο ή/και έναν μέγιστο αριθμό πόντων',
        en: 'Type in a minimum and/or a maximum number of points',
        it: 'Digitare il numero minimo e/o massimo di punti',
      },
      typeMinMaxTransactions: {
        el: 'Πληκτρολογήστε έναν ελάχιστο ή/και έναν μέγιστο αριθμό συναλλαγών',
        en: 'Type in a minimum and/or a maximum number of transactions',
        it: 'Digitare un numero minimo e/o massimo di transazioni',
      },
      typeMinMaxAge: {
        el: 'Πληκτρολογήστε μια ελάχιστη ή/και μέγιστη ηλικία για τους συμμετέχοντες',
        en: 'Type in a minimum and/or a maximum age for participants',
        it: "Digitare l'età massima e/o minima dei partecipanti",
      },
      typeMinMaxCurrency: {
        el: 'Πληκτρολογήστε ένα ελάχιστο ή/και ένα μέγιστο ποσό',
        en: 'Type in a minimum and/or a maximum amount',
        it: 'Digitare un importo minimo e/o massimo',
      },
      chooseDates: {
        el: 'Επιλέξτε τις ημερομηνίες',
        en: 'Choose the dates',
        it: 'Scegliere le date',
      },
      typeInNumberOfDays: {
        el: 'Πληκτρολογήστε τον αριθμό των ημερών',
        en: 'Type in number of days',
        it: 'Digitare il numero di giorni',
      },
      chooseCoupon: {
        el: 'Επιλέξτε Κουπόνι',
        en: 'Choose a Coupon',
        it: 'Scegliere un Coupon',
      },
      chooseCouponRewardDesc: {
        el: 'Επιλέξτε ένα κουπόνι για να δώσετε ως ανταμοιβή για την καμπάνια',
        en: 'Choose a Coupon to give as a reward for the campaign',
        it: 'Scegliere un Coupon da regalare come ricompensa per la campagna',
      },
      redemptionPeriod: {
        el: 'Περίοδος εξαργύρωσης (σε ημέρες)',
        en: 'Redemption Period (in days)',
        it: 'Periodo di riscatto (in giorni)',
      },

      redemptionPeriodDesc: {
        el: 'Στην συνέχεια, μπορείτε να επιλέξετε πόσες έγκυρες ημέρες θα είναι για τον χρήστη προκειμένου να εξαργυρώσει αυτό το κουπόνι, ή μπορείτε να το αφήσετε κενό (θα λάβει την προεπιλεγμένη τιμή της εταιρείας).',
        en: "After, you can choose how many valid days is going to be for the user in order to redeem  this coupon, or you can leave it blank (will take the company's default value)",
        it: "Dopo, è possibile scegliere quanti giorni di validità deve avere l'utente per riscattare il coupon, oppure si può lasciare vuoto (verrà preso il valore predefinito dell'azienda).",
      },

      dragSharePointsDesc: {
        el: 'Σύρετε την καρφίτσα ή πληκτρολογήστε στα πεδία για να προσαρμόσετε το ποσοστό του μεριδίου.',
        en: 'Drag the pin or type in the fields to adjust the share percentage.',
        it: 'Trascinare il perno o digitare nei campi per regolare la percentuale di condivisione.',
      },
      company: {
        el: 'Εταιρεία',
        en: 'Company',
        it: 'Azienda',
      },
      store: {
        el: 'Κατάστημα',
        en: 'Store',
        it: 'Negozio',
      },
      noChannelTitle: {
        el: 'Χωρις καναλι ειδοποιησης',
        en: 'No notification channel',
        it: 'Nessun canale di notifica',
      },
      noChannelDescription: {
        el: 'Δεν θα αποσταλούν ενημερωτικές ειδοποιήσεις για αυτή την καμπάνια.',
        en: 'No informative notifications will be sent for this campaign.',
        it: 'Per questa campagna non verranno inviate notifiche informative.',
      },
      goalTypes: {
        el: 'Τύπος στόχου',
        en: 'Goal Type',
        it: 'Tipo di obiettivo',
      },
      transactions: {
        el: 'Συναλλαγές',
        en: 'Transactions',
        it: 'Transazioni',
      },
      total_points: {
        el: 'Σύνολο πόντων',
        en: 'Total Points',
        it: 'Punti totali',
      },
      total_price: {
        el: 'Σύνολο τιμών',
        en: 'Total Price',
        it: 'Prezzo totale',
      },
      total_litres: {
        el: 'Σύνολο λίτρων',
        en: 'Total Litres',
        it: 'Litri totali',
      },
      transactions_number: {
        el: 'Αριθμός Συναλλαγών',
        en: 'Number of Transactions',
        it: 'Numero di transazioni',
      },
      total_points_number: {
        el: 'Αριθμός συνόλου πόντων',
        en: 'Total Points number',
        it: 'Punti totali',
      },
      total_price_number: {
        el: 'Αριθμός συνόλου τιμών',
        en: 'Total Price',
        it: 'Prezzo totale',
      },
      total_litres_number: {
        el: 'Αριθμός συνόλου λίτρων',
        en: 'Total Litres',
        it: 'Litri totali',
      },
      _number: {
        el: 'Αριθμός συνόλου',
        en: 'Total number',
        it: 'Numero totale',
      },
      hasEndDate: {
        el: 'Η καμπάνια έχει ημερομηνία λήξης',
        en: 'The campaign has an end date',
        it: 'La campagna ha una data di scadenza',
      },
      birth_dateCharacteristic: {
        el: 'Ηλικία',
        en: 'Age',
        it: 'Età',
      },
      executesOnBirthday: {
        el: 'Η καμπάνια εκτελείται σε ημέρα γενεθλίων',
        en: 'The campaign executes on birthday',
        it: 'La campagna si svolge in occasione del compleanno',
      },
      singleParticipation: {
        el: ' για απλή συμμετοχή',
        en: ' for single participation',
        it: ' per partecipazione singola',
      },
      doublePraticipation: {
        el: ' για διπλή συμμετοχή',
        en: ' for double participation',
        it: ' per doppia partecipazione',
      },
      selectReward: {
        el: 'Επιλέξτε επιβράβευση',
        en: 'Select a Reward',
        it: 'Selezionare un premio',
      },
      selectedReward: {
        el: 'Επιλεγμένη επιβράβευση',
        en: 'Selected Reward',
        it: 'Premio selezionato',
      },
      count: {
        el: 'Αριθμός νικητών',
        en: 'Winners Number',
        it: 'Numero di vincitori',
      },
      countError: {
        el: 'Απαιτείται τουλαχιστον 1 νικητής',
        en: 'At least 1 winner required',
        it: 'È richiesto almeno 1 vincitore',
      },
      addNew: {
        el: 'Προσθήκη νέου',
        en: 'Add new',
        it: 'Aggiungi nuovo',
      },
      uploadNewImage: {
        el: 'Φόρτωση νέας εικόνας',
        en: 'Upload New Image',
        it: 'Caricare una nuova immagine',
      },
      pointShareDescription: {
        el: 'Οι πόντοι της καμπάνιας μπορούν να χρεωθούν μερικώς ή πλήρως , είτε στην Εταιρεία είτε στο κατάστημα όπου έγινε η ενέργεια του χρήστη.',
        en: "Campaign's points can be charged partially or fully , either to Company or to the store where user's action happened.",
        it: "I punti della campagna possono essere addebitati parzialmente o totalmente all'azienda o al negozio in cui è avvenuta l'azione dell'utente.",
      },
      cashbackShareDescription: {
        el: 'Το ποσό cashback της καμπάνιας μπορεί να χρεωθεί μερικώς ή πλήρως , είτε στην Εταιρεία είτε στο κατάστημα όπου έγινε η ενέργεια του χρήστη.',
        en: "Campaign's cashback amount can be charged partially or fully , either to Company or to the store where user's action happened.",
        it: "L'importo del cashback della campagna può essere addebitato parzialmente o totalmente all'azienda o al negozio in cui è avvenuta l'azione dell'utente.",
      },
      basedOnMinMaxCompleted: {
        el: 'Επιλέξτε πελάτες με βάση έναν ελάχιστο ή/και έναν μέγιστο αριθμό συναλλαγών (π.χ. πελάτες που έχουν πραγματοποιήσει από 20 έως 100 συναλλαγές ή πελάτες που έχουν πραγματοποιήσει πάνω από 100 συναλλαγές).',
        en: 'Select customers based on a min and/or max number of transactions (e.g. customers who have completed between 20 and 100 transactions or customers who have completed over 100 transactions).',
        it: 'Selezionare i clienti in base a un numero minimo e/o massimo di transazioni (ad esempio, clienti che hanno completato tra 20 e 100 transazioni o clienti che hanno completato più di 100 transazioni).',
      },
      basedOnTransactionDays: {
        el: 'Επιλογή πελατών με καμία ολοκληρωμένη συναλλαγή για έναν αριθμό ημερών (π.χ. πελάτες των οποίων η τελευταία συναλλαγή είναι πάνω από 60 ημέρες πριν).',
        en: 'Select customers with no transactions completed for a number of days. (e.g. customers whose last transaction is over 60 days before).',
        it: 'Selezionare i clienti che non hanno effettuato transazioni per un certo numero di giorni. (ad esempio, i clienti la cui ultima transazione risale a più di 60 giorni prima).',
      },
      numberOfDays: {
        el: 'Αριθµός ηµερών',
        en: 'Number of days',
        it: 'Numero di giorni',
      },
      selectAll: {
        el: 'Επιλογή Όλων',
        en: 'Select All',
        it: 'Seleziona tutti',
      },
      minimum_transctions: {
        el: 'Ελάχιστος αριθμός συναλλαγών',
        en: 'Minimum number of transactions',
        it: 'Numero minimo di transazioni',
      },

      minimum_points: {
        el: 'Ελάχιστος αριθμός πόντων',
        en: 'Minimum number of points',
        it: 'Numero minimo di punti',
      },

      minimum_cashback: {
        el: 'Ελάχιστος αριθμός cashback',
        en: 'Minimum amount of cashback',
        it: 'Importo minimo di cashback',
      },
      maximum_transactions: {
        el: 'Μέγιστος αριθμός συναλλαγών',
        en: 'Maximum number of transactions',
        it: 'Numero massimo di transazioni',
      },

      maximum_points: {
        el: 'Μέγιστος αριθμός πόντων',
        en: 'Maximum number of points',
        it: 'Numero massimo di punti',
      },
      maximum_cashback: {
        el: 'Μέγιστος αριθμός cashback',
        en: 'Maximum amount of cashback',
        it: 'Importo massimo di cashback',
      },
      channelSubject: {
        el: 'Θέμα',
        en: 'Subject',
        it: 'Soggetto',
      },
      testSent: {
        el: 'Το τεστ στάλθηκε με επιτυχία',
        en: 'Test sent successfully',
        it: 'Test inviato con successo',
      },
      testFailed: {
        el: 'Το τεστ απέτυχε',
        en: 'Test failed',
        it: 'Test fallito',
      },
      emailThemes: {
        el: 'Πρότυπα email',
        en: 'Email Themes',
        it: 'Modelli di e-mail',
      },
      loyalties: {
        el: 'Προγράμματα Πιστότητας',
        en: 'Loyalty Programs',
        it: 'Programmi di fidelizzazione',
      },
      loyaltiesSelected: {
        el: 'Επιλεγμένα Προγράμματα Πιστότητας',
        en: 'Selected Loyalty Programs',
        it: 'Programmi di fidelizzazione selezionati',
      },
      numberOf_points: {
        el: 'Αριθμός πόντων',
        en: 'Number Of Points',
        it: 'Numero di punti',
      },
      numberOf_cashback: {
        el: 'Ποσό cashback',
        en: 'Amount Of Cashback',
        it: 'Importo del cashback',
      },
      select_pointsReached: {
        el: 'Συμπληρώστε τον αριθμό πόντων',
        en: 'Type in the nymber of points',
        it: 'Digitare il numero di punti',
      },
      select_cashbackReached: {
        el: 'Πληκτρολογήστε το ποσό του cashback',
        en: 'Type in the amount of cashback',
        it: "Digitare l'importo del cashback",
      },
      select_pointsReachedDiscription: {
        el: 'Συμπληρώστε τον αριθμό πόντων που πρέπει να φτάσει ένας πελάτης μετά από μια συναλλαγή',
        en: 'Type in the nymber of points a customer should reach after a transaction.',
        it: 'Digitare il numero di punti che un cliente deve raggiungere dopo una transazione.',
      },
      select_cashbackReachedDiscription: {
        el: 'Πληκτρολογήστε το ποσό του cashback που πρέπει να φτάσει ένας πελάτης μετά από μια συναλλαγή.',
        en: 'Type in the amount of cashback a customer should reach after a transaction.',
        it: "Digitare l'importo del cashback che un cliente deve raggiungere dopo una transazione.",
      },
      addNewAttribute: {
        el: 'Προσθήκη νέας Ιδιότητας Λογαριασμού Χρήστη',
        en: 'Add a new User Account Attribute',
        it: "Aggiungere un nuovo attributo dell'account utente",
      },
      selectAttributes: {
        el: 'Επιλογή Ιδιοτήτων λογαριασμού χρήστη',
        en: 'Select User Account Attributes',
        it: 'Selezionare Attributi account utente',
      },
      selectAttributesDis: {
        el: 'Επιλέξτε ένα ή περισσότερα χαρακτηριστικά λογαριασμού χρήστη και διαμορφώστε τη συνθήκη εξίσωσης ή ανίσωσης.',
        en: 'Select one or more user account attributes and form their equation condition.',
        it: "Selezionare uno o più attributi dell'account utente e configurare la condizione di equazione.",
      },
      attribute: {
        el: 'Ιδιότητα',
        en: 'Attribute',
        it: 'Attributo',
      },
      operator: {
        el: 'Τελεστής',
        en: 'Operator',
        it: 'Operatore',
      },
      values: {
        el: 'Τιμές',
        en: 'Values',
        it: 'Valori',
      },
      value: {
        el: 'Τιμή',
        en: 'Value',
        it: 'Valore',
      },
      selectTransactionCategory: {
        el: 'Επιλέξτε Τύπο Ενέργειας',
        en: 'Select Action Type',
        it: 'Selezionare il tipo di azione',
      },
      registerTransactionCategory: {
        el: 'ΕΓΓΡΑΦΗ',
        en: 'REGISTRATION',
        it: 'REGISTRAZIONE',
      },
      orderTransactionCategory: {
        el: 'ΑΓΟΡΑ',
        en: 'ORDER',
        it: 'ORDINE',
      },
      min_points: {
        el: 'Ελάχιστοι πόντοι ανά συναλλαγή',
        en: 'Minimum points per transaction',
        it: 'Punti minimi per transazione',
      },
      min_cashback: {
        el: 'Ελάχιστο cashback ανά συναλλαγή',
        en: 'Minimum cashback per transaction',
        it: 'Cashback minimo per transazione',
      },

      offline_registration_points: {
        el: 'Offline Πόντοι Εγγραφής',
        en: 'Offline Registration Points',
        it: 'Offline Punti di Registrazione',
      },
      offline_registration_cashback: {
        el: 'Offline Cashback Εγγραφής',
        en: 'Offline Registration Cashback',
        it: 'Offline Cashback di Registrazione',
      },

      online_registration_points: {
        el: 'Online Πόντοι Εγγραφής',
        en: 'Online Registration Points',
        it: 'Online Punti di Registrazione',
      },
      online_registration_cashback: {
        el: 'Online Cashback Εγγραφής',
        en: 'Online Registration Cashback',
        it: 'Online Cashback di Registrazione',
      },

      reward_points: {
        el: 'Πόντοι',
        en: 'Reward Points',
        it: 'Punti',
      },
      reward_cashback: {
        el: 'Cashback',
        en: 'Reward Cashback',
        it: 'Cashback',
      },

      type_reward_points_number: {
        el: 'Πληκτρολογήστε τον αριθμό των πόντων',
        en: 'Type in the number of points',
        it: 'Digitare il numero di punti',
      },
      type_reward_cashback_number: {
        el: 'Πληκτρολογήστε τον αριθμό του cashback',
        en: 'Type in the amount of cashback',
        it: "Digitare l'importo del cashback",
      },

      reward_points_description: {
        el: 'Πληκτρολογήστε τον αριθμό των πόντων που θα ανταμειφθούν στους συμμετέχοντες αυτής της καμπάνιας.',
        en: 'Type in the number of points that will be rewarded to the participants of this campaign.',
        it: 'Digitare il numero di punti che verranno assegnati ai partecipanti a questa campagna.',
      },
      reward_cashback_description: {
        el: 'Πληκτρολογήστε το ποσό του cashback που θα ανταμειφθεί στους συμμετέχοντες αυτής της καμπάνιας.',
        en: 'Type in the amount of cashback that will be rewarded to the participants of this campaign.',
        it: "Digitare l'importo del cashback che verrà assegnato ai partecipanti a questa campagna.",
      },

      multi_points_choose: {
        el: 'Επιλέξτε πολλαπλασιαστή',
        en: 'Choose a multiplier',
        it: 'Scegliere un moltiplicatore',
      },
      multi_cashback_choose: {
        el: 'Επιλέξτε πολλαπλασιαστή cashback',
        en: 'Choose a cashback multiplier',
        it: 'Scegliere un moltiplicatore di cashback',
      },

      multi_points_desc: {
        el: 'Ο πολλαπλασιαστής θα διαμορφώνει τους πόντους που κερδίζουν οι πελάτες κατα την διάρκεια της καμπάνιας (πχ. διπλάσιους πόντους από συναλλαγές).',
        en: 'The multiplier will modulate the points earned by customers during the campaign (e.g. double points from transactions).',
        it: 'Il moltiplicatore modulerà i punti guadagnati dai clienti durante la campagna (ad esempio, raddoppiando i punti delle transazioni).',
      },
      multi_cashback_desc: {
        el: 'Ο πολλαπλασιαστής θα διαμορφώνει το cashback που κερδίζουν οι πελάτες κατα την διάρκεια της καμπάνιας.',
        en: 'The multiplier will modulate the cashback earned by customers during the campaign.',
        it: 'Il moltiplicatore modulerà il cashback guadagnato dai clienti durante la campagna.',
      },

      total_cashback: {
        el: 'Σύνολο Cashback',
        en: 'Total Cashback',
        it: 'Cashback Totale',
      },

      total_cashback_number: {
        el: 'Αριθμός συνόλου cashback',
        en: 'Total Cashback number',
        it: 'Cashback totale',
      },

      points_earned_characteristic: {
        el: 'Από Χ έως Υ κερδισμένοι πόντοι',
        en: 'From X to Y points earned',
        it: 'Da X a Y punti guadagnati',
      },
      cashback_earned_characteristic: {
        el: 'Από Χ έως Υ κερδισμένο cashback',
        en: 'From X to Y cashback earned',
        it: 'Da X a Y cashback guadagnato',
      },

      points_reached_characteristic: {
        el: 'Πόντοι που επιτεύχθηκαν',
        en: 'Points reached',
        it: 'Punti raggiunti',
      },
      cashback_reached_characteristic: {
        el: 'Cashback που επιτεύχθηκε',
        en: 'Cashback reached',
        it: 'Cashback raggiunto',
      },

      type_min_max_points: {
        el: 'Πληκτρολογήστε ένας ελάχιστο ή/και έναν μέγιστο αριθμό πόντων',
        en: 'Type in a minimum and/or a maximum number of points',
        it: 'Digitare il numero minimo e/o massimo di punti',
      },
      type_min_max_cashback: {
        el: 'Πληκτρολογήστε ένα ελάχιστο ή/και ένα μέγιστο ποσό cashback',
        en: 'Type in a minimum and/or a maximum amount of cashback',
        it: 'Digitare un importo minimo e/o massimo di cashback',
      },
    },
  }),
};
